import { css } from '@emotion/css/macro';
import Color from '../../../../common/Color';
import StyleConstants from '../../../../common/StyleConstants';

const style = css`
  max-width: ${StyleConstants.MAX_WIDTH}px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: 40px 0;
  #problemImg {
    width: 234px;
    left: 0;
    margin: 0 auto 34px;
  }
  p {
    padding: 10px 22px;
    margin: 5px 27px 10px 0;
    border-radius: 13px 0 13px 13px;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.27);
    border: solid 1px #f4f4f4;
    background-color: ${Color.WHITE};
    font-size: 16px;
    font-weight: bold;
    line-height: 1.19;
    letter-spacing: -0.6px;
    color: #42607f;
    text-align: center;
  }
`;

export default function ProblemView() {
  return (
    <section className={style}>
      <img id='problemImg' src='//static.dogmate.co.kr/dogit/landing-v3/dogit-v3-problem.png' />
      <p>왜 자꾸 짖지? 😭</p>
      <p>왜 사람만 보면 달려들지? 😩</p>
      <p>왜 물려고 하는 걸까? 😱</p>
    </section>
  );
}
